<div [formGroup]="formGroup" autocomplete="off">
  <div *ngIf="isNewDocument">
    <nc-file-upload [id]="fileUploadId" [formGroup]="formGroup"
                    formControlName="file"
                    label="file">
    </nc-file-upload>
  </div>
  <nc-input [id]="inputId" [formGroup]="formGroup"
            formControlName="name"
            label="name">
  </nc-input>
  <nc-select [id]="selectId" [searchButtonId]="selectSearchButtonId" [searchTextId]="selectSearchTextId" [clearIconId]="selectClearIconId"
             [formGroup]="formGroup"
             [enableSelectAll]="false"
             formControlName="documentType"
             label="documentType"
             [data$]="documentTypes$">
  </nc-select>
</div>
